import React from "react";
import TwoFactorAuthentication from "../auth/TwoFactorAuthentication";

const OptionsTwoFactorAuthentication = () => {
  return <TwoFactorAuthentication isFromOptions />;
};

export default OptionsTwoFactorAuthentication;
